<template>
    <hts-slide-over
        :show="props.show"
        color="main"
        :submit="handleSubmitFormEditGroup"
        :width="sizeSlideOver"
        :undo-enable="true"
        :title="groupIsSelectedToEdit?.name"
        @close="handleClose"
        @undo="undo">
        <template #body>
            <div class="hts-company-group-ignore-add-group">
                <div
                    class="hts-company-group-ignore-add-group__container-body"
                    :class="sizeItemInput">
                    <hts-card>
                        <template #title>
                            <h3 class="title">
                                <span class="label">
                                    {{ $t('labels.editGroup') }}
                                </span>
                            </h3>
                        </template>
                        <div
                            class="grid gap-5"
                            :class="columnClass">
                            <hts-form-input
                                v-model="dataFormCompanyGroup.name"
                                :label="$t('labels.groupName')"
                                :required="true"
                                :color="props.color"
                                name="name"
                                prop="name" />
                            <hts-form-input
                                :placeholder="companyName"
                                :label="$t('labels.companyName')"
                                :color="props.color"
                                :disabled="true"
                                name="company"
                                prop="company" />
                            <hts-form-input
                                v-model="dataFormCompanyGroup.description"
                                :label="$t('labels.description')"
                                :color="props.color"
                                name="description"
                                prop="description" />
                        </div>
                    </hts-card>
                </div>
            </div>
        </template>
    </hts-slide-over>
</template>

<script setup lang="ts">
import dataForm from './imports/model'

const store = $store()
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: Number,
    default: 0
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  groupIsSelectedToEdit: {
    type: Object,
    default: () => {}
  }
})
const emits = defineEmits(['close', 'refreshTables', 'undo'])
const handleClose = () => {
  emits('close')
}
watch(props, () => {
  _init()
})
const _init = () => {
  Object.assign(dataFormCompanyGroup, props.groupIsSelectedToEdit)
}
const undo = () => {
  _init()
}
const companyName = ref('')
onMounted(() => {
  companyName.value = store.system.company.name
})
const dataFormCompanyGroup = reactive({ ...dataForm.initValue })

const handleSubmitFormEditGroup = () => {
  const api = $url.companyGroup.editGroup
  const data = {
    id: props.groupIsSelectedToEdit._id,
    name: dataFormCompanyGroup.name,
    description: dataFormCompanyGroup.description
  }
  $api(api, { body: new URLSearchParams(data) })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (!responseData) {
        return true
      }
      if (responseData.success) {
        Object.assign(dataFormCompanyGroup, { ...data })
        emits('refreshTables')
        process.client && $toast().success($t('labels.editSuccess'))
        emits('close')
        undo()
      }
    })
    .catch((error: any) => error)
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-5'
})
</script>
